/**
 * Main User Interface Actions
 * @type {Object}
 */
SITE.UI = {

    viewport: {
        width: 0,
        height: 0,
        mode: "", // xl, lg, md, sm, xs
        touch: false,
        scrollTop: 0
    },

    breakpoints: {
        "xs": 0,
        "sm": 544,
        "md": 768,
        "lg": 992,
        "xl": 1200
    },

    containerWidths: {
        "sm": 576,
        "md": 750,
        "lg": 960,
        "xl": 1100
    },

    init: function() {
        "use strict";

        // Lazy loading
        $('.lazy').Lazy();

        // Navigation
        SITE.UI.nav.init();
        
        // Automated Form Validation
        SITE.Utils.Validate.init();

        // Record Vieport Size
        SITE.UI.setSize();
        $(window).resize(function() {
            SITE.UI.setSize();
            // SITE.UI.CardGrid.init();
            SITE.Utils.eqHeight();
        });

        // Card Grid Heights
        // SITE.UI.CardGrid.init();

        // Check if device is touch
        SITE.UI.viewport.touch =  (('ontouchstart' in window) || (navigator.MaxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0));

        SITE.Utils.backToTopBtn();


        // Equalize Column Heights
        SITE.Utils.eqHeight();

        // InView 
        $('.inview').on('inview', function(event, isInView) {
            if (isInView) {
                $(this).addClass('in-view');
            }
        });

        // Add effect on page load
        $('body').removeClass('is-loading');
        
        // Special URLS
        switch (window.location.hash) {
            case '#clients':
                SITE.UI.scrollTo('#featClients');
                break;
        }

        SITE.UI.toc();
        SITE.UI.internalLinks();

        SITE.UI.clickableImg();

        SITE.UI.customLinks();

        SITE.UI.SlickCarousel.init();
        $(window).resize(function() {
            SITE.UI.SlickCarousel.init();
        });

        SITE.UI.relatedSidebar();
        SITE.UI.animatedCTAs();

        // Masonry layout for testimonials
        if($('.testimonials-grid').length > 0) {

            $('.grid').masonry({
                itemSelector: '.grid-item',
                columnWidth: '.grid-sizer',
                percentPosition: true
            });

        }

        SITE.UI.cookieConsent();

        $('a[data-scroll-to]').click(function() {
            SITE.UI.scrollTo($(this).attr('data-scroll-to'));

            return false;
        });

    },

    setSize: function() {
        "use strict";
        
        var w;
        
        SITE.UI.viewport.width = w = $(window).width();
        SITE.UI.viewport.height = $(window).height();

        $.each(SITE.UI.breakpoints, function(mode, width) {
            if (w > width) SITE.UI.viewport.mode = mode;
        });
        
    },


    nav: {

        stickyNavOn: true,

        init: function() {
            "use strict";

            $(".dropdown-toggle").dropdown();

            if ($("body").hasClass("no-sticky-nav")) SITE.UI.nav.stickyNavOn = false;
            
            SITE.UI.nav.sticky();
            SITE.UI.nav.mobile();

            // Third level dropdown
            $('.dropdown-submenu a.third-level-dropdown').on('click', function(e) {
                $('.dropdown-menu--3rd-level').hide();
                $(this).next('ul').toggle();
                e.stopPropagation();
                e.preventDefault();
            });
        },

        sticky: function() {
            "use strict";

            $(window).scroll(function() {

                // Save scrolltop to be used by others
                SITE.UI.viewport.scrollTop = $(window).scrollTop();

                if (SITE.UI.nav.stickyNavOn) {

                    if (!$("body").hasClass("no-nav")) {

                        if (SITE.UI.viewport.scrollTop > 115) $("body").addClass("sticky-nav");
                        else $("body").removeClass("sticky-nav");

                    }
                }
                
            });
        },

        mobile: function() {
            "use strict";

            $("#hamburger").click(function() {
                $("body").toggleClass("mob-nav-open");
                $(this).toggleClass("is-active");

                /*if($('body').hasClass('mob-nav-open')) {
                    SITE.UI.nav.stickyNavOn = false;
                    $("body").removeClass("sticky-nav");
                } else {
                    SITE.UI.nav.stickyNavOn = true;
                    $("body").addClass("sticky-nav");
                }*/
            });
        }

    },


    /**
     * Make all cards equal height
     * ----------------------------
     * Used in Services HUb Page
     */
    // CardGrid: {
        
    //     run: true,

    //     init: function() {
    //         "use strict";

            

    //         if (SITE.UI.viewport.mode === "xs") {
                
    //             if (this.run === true) {
    //                 // Reset Heights
    //                 $(".card-grid").each(function() {
    //                     $(this).children().each(function() {
    //                         $(this).children('div').height('auto');
    //                     });
    //                 });
    //             }
                
    //             return false;
            
    //         } else {
    //             this.run = true;
    //             $(".card-grid img").load(function() {
    //                 SITE.UI.CardGrid.setEqualHeights();
    //             });
    //         }

    //         this.setEqualHeights();

            
    //     },

        // setEqualHeights: function() {
        //     "use strict";

        //     var h = 0,
        //         maxH = 0,
        //         cards;

        //     $(".card-grid").each(function() {
                
        //         maxH = 0;

        //         cards = $(this).children();
                
        //         // Reset Heights
        //         cards.each(function() {
        //             $(this).children('div').height(0);
        //         });
                
        //         cards.each(function() {
        //             h = $(this).height();
        //             if (h > maxH) maxH = h;
        //         });
                
        //         // Fix because IMG is outside wrapper div
        //         if ($("body").hasClass("post-slug-locations")) {
        //             maxH -= 150;
        //         }

        //         cards.each(function() {
        //             $(this).children('div').height(maxH);
        //         });
        //     });
        // }

    // },


    /**
     * Table of Contents Generator
     * ---------------------------
     * @return {[type]} [description]
     */
    toc: function() {
        "use strict";

        var el = $("#toc,#hoverTocNav"),
            html, anchor;

        if (el.length > 0) {
            
            html = "";

            $("h2").each(function(i) {

                anchor = $(this).attr("id");
                if (!anchor) {
                    anchor = "h" + i;
                    $(this).attr("id", anchor);
                }

                html += "<li><a href='#" + anchor + "'>" + $(this).text() + "</a></li>";

            });

            html = "<ol>" + html + "</ol>";

            el.append(html);
        }
    },



    internalLinks: function() {
        "use strict";

        $("a[href^='#']").not("[data-toggle=modal]").click(function() {
            SITE.UI.scrollTo($(this).attr("href"));
            return false;
        });
    },

    /**
     * Scroll the page to given element
     * @param  {[type]} elID jQuery Selector
     */
    scrollTo: function(elID) {
        "use strict";

        //if(($('body').data('page') == 'landing') || 
            //($('body').data('page') == 'epicres')) {

            // // Works only for Landing page layout for now because it was disabled before
            // // and we keep it disabled to avoid unexpected problems in other site parts
            // if(SITE.UI.viewport.mode == 'xs' || SITE.UI.viewport.mode == 'md') {

            //     // Scroll to the given element directly
            //     var scrollTopValue = ($(elID).offset().top - 200);

            // } else {

            //     // Scroll to top because of fixed position
            //     var scrollTopValue = 0;

            // }
            var scrollTopValue = ($(elID).offset().top - 200) || 0;

            console.log(scrollTopValue);
            $('html, body').animate({
                scrollTop: scrollTopValue
            }, 600);

        //}
    },

    clickableImg: function() {
        "use strict";

        var m,w,h, src; 

        $("img.clickable").click(function() {
            
            src = $(this).attr("src");

            // Get image original dimensions
            $("<img/>")
                .attr("src", src)
                .load(function() {
                        
                    w = this.width;   // Note: $(this).width() will not
                    h = this.height;  // work for in memory images.

                    m = $("#imgModal");
                    
                    m.find(".modal-body img")
                        .attr("src", $(this).attr("src"))
                        .attr("width", w)
                        .attr("height", h);

                    m.find(".modal-dialog")
                        .css("width", w + "px")
                        .css("height", h + "px");

                    m.modal('show');

                });
        });
    },

    /**
     * Initialize Custom Links
     * ------------------------
     * 
     * @return {[type]} [description]
     */
    customLinks: function() {
        "use strict";

        // Start new livechat convo
        $("[data-target=open-chat]").click(function() {

            // In case intercom is hidden
            $("#intercom-container").show();
            
            Intercom('showNewMessage');
            return false;
        });
    },


    /**
     * Slick Carousel
     * ----------------
     *
     * Used on
     * - Ranking table
     * - Landing logos
     * - Featured testimonials
     * 
     * @type {Object}
     */
    SlickCarousel: {

        init: function() {
            "use strict";

            SITE.UI.SlickCarousel.videosList();
            SITE.UI.SlickCarousel.rankingTables();
            SITE.UI.SlickCarousel.landingLogos();
            SITE.UI.SlickCarousel.featuredTestimonials();
        },

        videosList: function() {
            "use strict";

            if($('.videos-list').length > 0) {

                $('.videos-list').each(function() {

                    var $sliderElement = $(this);
                    var $relatedNavElement = $sliderElement.parent().find('.videos-list-nav');
                    var $relatedPrevElement = $sliderElement.parent().find('.videos-list-prev');
                    var $relatedNextElement = $sliderElement.parent().find('.videos-list-next');

                    $sliderElement.slick({
                        infinite: true,
                        dots: true,
                        arrows: false,
                        unslick: true
                    });

                    $relatedNextElement.on('click', function(){
                        $sliderElement.slick('slickNext');
                    });
                    $relatedPrevElement.on('click', function(){
                        $sliderElement.slick('slickPrev');
                    });

                });

            }
        },

        rankingTables: function() {
            "use strict";

            // Only enable for MD and under
            if (SITE.UI.viewport.mode !== 'xs'
                    && SITE.UI.viewport.mode !== 'sm'
                    && SITE.UI.viewport.mode !== 'md') {
                
               // $('.sg-review-table ol').unslick();

            //return false;
            }

            if($('.sg-review-table ol').length > 0 && ! $('.sg-review-table ol').hasClass('slick-initialized')) {

                $('.sg-review-table ol').slick({
                    infinite: true,
                    arrows: true,
                    slidesToShow: 4,
                    slidesToScroll: 4,
                    dots: true,
                    unslick: true,

                    responsive: [
                        {
                            // MD
                            breakpoint: 3200,
                            settings: "unslick"
                        },
                        {
                            // MD
                            breakpoint: 992,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 2,
                            }
                        },{
                            // SM
                            breakpoint: 768,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 2,
                            }
                        },{
                            // XS
                            breakpoint: 576,
                            settings: {
                                arrows: false,
                                slidesToShow: 1,
                                slidesToScroll: 1,
                            }
                        }
                    ]
                });

            }
        },

        landingLogos: function() {
            "use strict";

            if($('.sg-landing-logos').length > 0 && ! $('.sg-landing-logos').hasClass('slick-initialized')) {

                $('.sg-landing-logos').slick({
                    infinite: true,
                    arrows: false,
                    dots: true,
                    unslick: true
                });

            }
        },

        featuredTestimonials: function() {
            "use strict";

            if($('.js-slick-testimonials').length > 0 && ! $('.js-slick-testimonials').hasClass('slick-initialized')) {

            $('.js-slick-testimonials').each(function(){
                var $sliderElement = $(this);
                var $relatedNavElement = $sliderElement.parent().find('.testimonials-nav')
                var $relatedPrevElement = $sliderElement.parent().find('.testimonials-prev')
                var $relatedNextElement = $sliderElement.parent().find('.testimonials-next')
                
                $sliderElement.slick({
                    infinite: true,
                    arrows: false,
                    dots: true,
                    unslick: true,
                    slidesToShow: 1,
                    appendDots: $relatedNavElement,
                    customPaging : function(slider, i) {
                        var thumb = $(slider.$slides[i]).find('div').attr('data-src-small');
                        var position = $(slider.$slides[i]).find('div').attr('data-position-small');

                        return '<a style="display: block; width: 70px; height: 70px; background: url(' + thumb + ') ' + position + ';"></a>';
                    }
                });

                $relatedNextElement.on('click', function(){
                    $sliderElement.slick('slickNext');
                });
                $relatedPrevElement.on('click', function(){
                    $sliderElement.slick('slickPrev');
                });
            });



            }
        }
    },

    relatedSidebar: function() {

        if($('body.single-post').length > 0 && $('.related-sidebar').length
             > 0) {

            // Slide ad when focus is on content area
            $(document).on( 'scroll', function() {

                if( $( this ).scrollTop() >= ( $( '.entry-content' ).position().top ) + 200 ) {
                    $('.related-sidebar').show();
                }

                if( $( '#previous-and-related' ).position().top < $( this ).scrollTop() ) {
                    $('.related-sidebar').hide();
                }

            } );

        }

    },

    animatedCTAs: function() {

        setTimeout(function() {
            $('#topRightFreeConsultCTA').addClass('animated tada');
        }, 5000);

    },

    cookieConsent: function() {

        if( typeof Cookies.get('cookie-consent-accepted') == 'undefined' ) {
            $('.cookie-bar').show();
        }

        $('#cookie-bar-accept').click(function() {
            Cookies.set('cookie-consent-accepted', 1, { expires: 365 });
            $('.cookie-bar').hide();
        });

    }

};